
export default {
  props: {
    src: {
      type: String, 
      default: ''
    },
    imageClass: {
      type: String, 
      default: ''
    },
    title: {
      type: String, 
      default: ''
    },
    alt: {
      type: String, 
      default: ''
    }
  }
}
